import { render } from "./ProcedureType.vue?vue&type=template&id=4f5b083a&scoped=true"
import script from "./ProcedureType.vue?vue&type=script&lang=js"
export * from "./ProcedureType.vue?vue&type=script&lang=js"

import "./ProcedureType.vue?vue&type=style&index=0&id=4f5b083a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5b083a"]])

export default __exports__